import React from 'react'
import { useLogout } from 'domains/authentication/hooks/useLogout'
import { Text } from 'lib/components'

export default function LogoutScreen() {
  const logout = useLogout()

  React.useEffect(() => {
    logout()
  }, [logout])

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <i className="text-secondary fas fa-arrow-right-from-bracket text-4xl" />
      <br />
      <Text className="text-2xl text-center">Logging out...</Text>
      <Text className="text-xl text-center">Please wait</Text>
    </div>
  )
}
